import { createFileRoute } from '@tanstack/react-router'
import { AggregationsPage } from '../../../components/AggregationsPage'

export const Route = createFileRoute('/$org/aggregations/')({
  component: () => <AggregationsPage />,
})
